function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.716,
    height: 34.194,
    viewBox: "0 0 35.716 34.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "01n"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14526",
    d: "M22.608 33.728a14.1 14.1 0 0 1-9.468-3.665h.912a15.058 15.058 0 0 0 12.1-24 14.061 14.061 0 0 1-3.542 27.663z",
    transform: "rotate(120 22.184 16.464)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14527",
    d: "M15.844 12.664a.4.4 0 0 0 .277-.2l.933-1.691.928 1.691a.4.4 0 0 0 .277.2l1.894.363-1.318 1.408a.384.384 0 0 0-.107.325l.24 1.91-1.744-.816a.384.384 0 0 0-.341 0l-1.75.816.24-1.91a.4.4 0 0 0-.1-.325l-1.323-1.409zM7.56 20.521l.155-1.238a.4.4 0 0 0-.107-.325l-.848-.907 1.222-.224a.416.416 0 0 0 .277-.2l.6-1.067.6 1.067a.4.4 0 0 0 .272.2l1.222.229-.864.9a.411.411 0 0 0-.107.325l.155 1.238-1.125-.533a.411.411 0 0 0-.341 0zm10.37 3.312a.4.4 0 0 0-.1.325l.155 1.232-1.125-.533a.4.4 0 0 0-.171-.037.379.379 0 0 0-.171.037l-1.125.533.155-1.232a.405.405 0 0 0-.107-.325l-.853-.907 1.222-.235a.405.405 0 0 0 .277-.2l.6-1.093.6 1.093a.405.405 0 0 0 .277.2l1.222.235z",
    transform: "rotate(120 21.33 18.422)",
    style: {
      fill: "#283593"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01N);
export default __webpack_public_path__ + "static/media/01N.9eb1754ca2a2d20530322472b524dff1.svg";
export { ForwardRef as ReactComponent };